import React, { useState } from "react";
import Sidebar from "./components/Sidebar";
import DoctorList from "./components/DoctorList";
import BookingForm from "./components/BookingForm";
import SlotDateSelection from "./components/SlotDateSelection";
import SlotList from "./components/SlotList";

function App() {
  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const [selectedDoctor, setSelectedDoctor] = useState(null);
  const [patientData, setPatientData] = useState(null);
  const [selectedSlotDate, setSelectedSlotDate] = useState(null);

  return (
    <div style={{ display: "flex" }}>
      <Sidebar
        onSelectDepartment={(id) => {
          setSelectedDepartment(id);
          setSelectedDoctor(null);
          setPatientData(null);
          setSelectedSlotDate(null);
        }}
        selectedDepartment={selectedDepartment}
      />

      <div style={{ flex: 1, padding: "20px" }}>
        {!selectedDoctor && (
          <DoctorList
            splid={selectedDepartment}
            onSelectDoctor={setSelectedDoctor}
          />
        )}

        {selectedDoctor && !patientData && (
          <BookingForm
            doctor={selectedDoctor}
            onSuccess={(patient) => setPatientData(patient)}
            onBack={() => setSelectedDoctor(null)}
          />
        )}

        {selectedDoctor && patientData && !selectedSlotDate && (
          <SlotDateSelection
            doctor={selectedDoctor}
            patient={patientData}
            onSelectDate={(date) => setSelectedSlotDate(date)}
            onBack={() => setPatientData(null)}
          />
        )}

        {selectedDoctor && patientData && selectedSlotDate && (
          <SlotList
            doctor={selectedDoctor}
            patient={patientData}
            slotdate={selectedSlotDate}
            onBack={() => setSelectedSlotDate(null)}
          />
        )}
      </div>
    </div>
  );
}
export default App;